import { Navigate, Outlet, createFileRoute, useLocation } from '@tanstack/react-router';
import { Suspense } from 'react';
import { VStack } from '@/components/Layout';
import { Loader } from '@/components/Loading';
import { hasLedgerSelfScope } from '@/lib/auth';
import { useLedgerDataScopes } from '@/routes/_individual/individual/-query/useLedgerDataScopes';
import { MyProfileHeader } from './-components/MyProfileHeader';
import { MY_PROFILE_TABS } from './-constants';
export const Route = createFileRoute('/_individual/individual/_profile/my-profile/_layout')({
  component: MyProfileLayout
});
function MyProfileLayout() {
  const dataScopes = useLedgerDataScopes();
  const {
    pathname
  } = useLocation();

  // プロダクト権限 my-profile 廃止に伴い、本人向け画面は台帳 self データスコープに連動する。
  // 対応台帳の self が有効なタブのみアクセス可能とする（backend はコントローラの宣言的 Guard で self を判定）。
  const visibleTabs = MY_PROFILE_TABS.filter(tab => hasLedgerSelfScope(dataScopes, tab.ledger));

  // 可視タブが 1 つも無い（self データスコープが全て無効）→ 個人トップへ退避する。
  if (visibleTabs.length === 0) {
    return <Navigate to="/individual" replace />;
  }

  // 現在のタブに対応する台帳 self が無効（直接 URL 遷移など）→ 先頭の可視タブへ寄せる。
  const currentTab = MY_PROFILE_TABS.find(tab => pathname.startsWith(tab.to));
  if (currentTab && !visibleTabs.some(tab => tab.to === currentTab.to)) {
    return <Navigate to={visibleTabs[0].to} replace />;
  }
  return <VStack className="flex h-full min-h-0 flex-col overflow-y-auto md:overflow-hidden">
      <Suspense fallback={<HeaderSkeleton />}>
        <MyProfileHeader />
      </Suspense>
      <div className="flex min-h-0 flex-1 flex-col md:overflow-hidden">
        <Outlet />
      </div>
    </VStack>;
}
function HeaderSkeleton() {
  return <div className="border-b border-neutral-muted-border">
      <VStack className="bg-neutral-fill px-6 lg:px-12 py-6 shadow-sm gap-4 items-center justify-center h-32">
        <Loader />
      </VStack>
    </div>;
}